(() => {
  const config = window.keyboardProductConfiguratorConfig;
  if (!config) return;

  const {
    product: currProduct,
    selectedVariant: currVariant,
    variants: currVariants,
    sectionId,
    productLabel = 'Keyboard',
    defaultCompareAt = null,
    colorPreviewVariants = {}
  } = config;
  var option1 = [];
  var option2 = [];
  var option3 = [];
  for (var i = 0; i < currProduct.variants.length; i++) {
    var variant = currProduct.variants[i];

    // Gathering values for the 1st drop-down.
    option1.push(variant.option1);
    option2.push(variant.option2);
    option3.push(variant.option3);
  }
  const optionL1 = [...new Set(option1)];
  const optionL2 = [...new Set(option2)];
  const optionL3 = [...new Set(option3)];
  var currOpt1 = optionL1.findIndex(e => e == currVariant.option1)
  var currOpt2 = optionL2.findIndex(e => e == currVariant.option2)
  var currOpt3 = optionL3.findIndex(e => e == currVariant.option3)

  $(document).ready(function() {
    const selectedKeycapExtras = new Map();
    const selectedSwitchExtras = new Map();
    const globalAddOnOpts = [0, 0, 0];
    let extraPrice = 0;
    let extraComparePrice = 0;
    // form treatment
    const addToCartForms = document.querySelectorAll(
      'product-form form[data-type="add-to-cart-form"]'
    );
  const currencySymbol = config.currencySymbol;

function formatMoney(cents) {
  return currencySymbol + (cents / 100).toFixed(2);
}

function getSelectedVariantId(form) {
  const formVariantInput = form ? form.querySelector('input[name="id"]') : null;
  const urlVariantId = new URLSearchParams(window.location.search).get("variant");
  const variantPicker = document.querySelector(
    `variant-radios[data-section="${sectionId}"]`
  );
  const selectedOptions = variantPicker
    ? Array.from(variantPicker.querySelectorAll('fieldset')).map((fieldset) => {
        const checkedInput = fieldset.querySelector('input:checked');
        return checkedInput ? checkedInput.value : null;
      })
    : [];
  const selectedVariant = selectedOptions.length > 0 && selectedOptions.every(Boolean)
    ? currVariants.find((variant) => {
        return variant.options.every((option, index) => option === selectedOptions[index]);
      })
    : null;

  return parseInt(
    (selectedVariant && selectedVariant.id)
      || (formVariantInput && formVariantInput.value)
      || urlVariantId
      || currVariant.id,
    10
  );
}

function getSelectedAccessoryItems() {
  return Array.from(
    document.querySelectorAll("[data-accessory-input]:checked")
  ).map((input) => {
    const item = {
      id: parseInt(input.dataset.variantId, 10),
      quantity: parseInt(input.dataset.quantity || "1", 10)
    };

    if (input.dataset.discount) {
      item.properties = {
        "_Bundle discount": input.dataset.discount + "% with keyboard"
      };
    }

    return item;
  }).filter((item) => Number.isInteger(item.id) && item.id > 0);
}

function getSelectedAccessoryTotals() {
  return Array.from(
    document.querySelectorAll("[data-accessory-input]:checked")
  ).reduce((totals, input) => {
    totals.price += parseInt(input.dataset.price || "0", 10);
    totals.comparePrice += parseInt(
      input.dataset.comparePrice || input.dataset.price || "0",
      10
    );
    return totals;
  }, { price: 0, comparePrice: 0 });
}

function buildCartItems(form) {
  const quantityInput = form.querySelector('input[name="quantity"]')
    || document.getElementById(`Quantity-${sectionId}`);
  const quantity = Math.max(parseInt(quantityInput ? quantityInput.value : "1", 10) || 1, 1);
  const items = [{
    id: getSelectedVariantId(form),
    quantity
  }];

  selectedKeycapExtras.forEach((keycapExtra) => {
    if (keycapExtra.variantId) {
      items.push({ id: keycapExtra.variantId, quantity });
    }
  });

  selectedSwitchExtras.forEach((switchExtra) => {
    if (switchExtra.variantId) {
      items.push({ id: switchExtra.variantId, quantity });
    }
  });

  return items.concat(getSelectedAccessoryItems());
}

function setFormLoading(form, isLoading) {
  const submitButton = form.querySelector(".product-form__submit");
  const spinner = submitButton ? submitButton.querySelector(".loading-overlay__spinner") : null;

  if (submitButton) {
    submitButton.disabled = isLoading;
    submitButton.setAttribute("aria-busy", isLoading ? "true" : "false");
  }

  if (spinner) {
    spinner.classList.toggle("hidden", !isLoading);
  }
}

function showFormError(form, message) {
  const productForm = form.closest("product-form");
  const errorWrapper = productForm
    ? productForm.querySelector(".product-form__error-message-wrapper")
    : null;
  const errorMessage = productForm
    ? productForm.querySelector(".product-form__error-message")
    : null;

  if (!errorWrapper || !errorMessage) return;

  if (message) {
    errorMessage.textContent = message;
    errorWrapper.removeAttribute("hidden");
  } else {
    errorMessage.textContent = "";
    errorWrapper.setAttribute("hidden", "");
  }
}

function escapeCartText(value) {
  const element = document.createElement("div");
  element.textContent = value == null ? "" : String(value);
  return element.innerHTML;
}

function populateCartNotification(cartData) {
  const notificationProduct = document.getElementById("cart-notification-product");
  if (!notificationProduct || !Array.isArray(cartData.items)) return;

  const productMarkup = cartData.items.map((item) => {
    const imageUrl = item.featured_image && item.featured_image.url
      ? escapeCartText(item.featured_image.url)
      : "";
    const imageMarkup = imageUrl
      ? `<img class="cart-notification-product__image" src="${imageUrl}" alt="${escapeCartText(item.title)}" width="70" height="43" loading="lazy">`
      : "";
    const optionsMarkup = (item.options_with_values || [])
      .filter((option) => {
        return !(
          String(option.name).trim().toLowerCase() === "title"
          && String(option.value).trim().toLowerCase() === "default title"
        );
      })
      .map((option) => `
        <dl>
          <div class="cart-notification-product__option h4">
            <dt>${escapeCartText(option.name)}: </dt>
            <dd>${escapeCartText(option.value)}</dd>
          </div>
        </dl>
      `).join("");

    return `
      <div class="cart-notification-product">
        ${imageMarkup}
        <div class="cart-notification-product__info">
          <h3 class="cart-notification-product__name h4">${escapeCartText(item.product_title)}</h3>
          ${optionsMarkup}
        </div>
      </div>
    `;
  }).join("");

  notificationProduct.innerHTML = `<div class="cart-notification-product-order">${productMarkup}</div>`;
}

async function updateCartNumber() {
  const response = await fetch("/cart.js", {
    headers: { "Accept": "application/json" }
  });

  if (!response.ok) throw new Error("Could not refresh the cart.");

  const cartData = await response.json();
  const cartQuantity = cartData.item_count || 0;
  const cartQuantityActual = document.querySelector(".cart-count-bubble [aria-hidden]");
  const cartNotificationButton = document.getElementById("cart-notification-button");

  if (cartQuantityActual) {
    cartQuantityActual.textContent = String(cartQuantity);
  }

  if (cartNotificationButton) {
    cartNotificationButton.textContent = `View my cart (${cartQuantity})`;
  }
}

async function submitConfiguredCart(form) {
  showFormError(form, "");
  setFormLoading(form, true);

  try {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ items: buildCartItems(form) })
    });
    const cartData = await response.json();

    if (!response.ok || cartData.status) {
      throw new Error(
        cartData.description || cartData.message || "Could not add this configuration to the cart."
      );
    }

    populateCartNotification(cartData);

    const cartNotification = document.getElementById("cart-notification");
    if (cartNotification) {
      cartNotification.classList.add("animate", "active");
    }

    try {
      await updateCartNumber();
    } catch (cartRefreshError) {
      console.error(`${productLabel} was added, but the cart count could not be refreshed`, cartRefreshError);
    }
  } catch (error) {
    console.error(`Error adding configured ${productLabel} to cart`, error);
    showFormError(form, error.message || "Could not add this configuration to the cart.");
  } finally {
    setFormLoading(form, false);
  }
}

function updatePrice() {
  const selVariant = getSelectedVariantId();

  let variant = currVariants.find(v => v.id === selVariant);
  if (!variant) return;

  // --- 1. Base prices from Shopify (raw, without extras) ---
  let basePrice   = variant.price;                        // in cents
  let baseCompare = variant.compare_at_price || defaultCompareAt || null;

  // --- 2. Apply your extraPrice for the displayed numbers ---
  let finalPrice   = basePrice + extraPrice;
  let finalCompare = (baseCompare && baseCompare > basePrice ? baseCompare : basePrice)
    + extraComparePrice;
  const isDiscounted = finalCompare > finalPrice;

  // --- 3. DOM refs ---
  var priceWrapper = document.getElementById('product-price');
  var regularSpan  = document.getElementById('product-price-regular');
  var saleSpan     = document.getElementById('product-price-sale');
  var compareSpan  = document.getElementById('product-price-compare');
  var saleBlock    = document.getElementById('product-price-sale-block');

  if (!priceWrapper || !regularSpan || !saleSpan || !compareSpan || !saleBlock) return;

  if (isDiscounted) {
    // ✅ Variant is on sale

    // Match Dawn: add sale class
    priceWrapper.classList.add('price--on-sale');

    // Show the sale block
    saleBlock.style.display = '';

    // Sale price (current)
    saleSpan.textContent = formatMoney(finalPrice);

    // Compared-at price (after, crossed out)
    compareSpan.textContent = formatMoney(finalCompare);

    // Regular span usually mirrors the original price in Dawn when on sale
    regularSpan.textContent = formatMoney(finalPrice);
  } else {
    // ❌ Not discounted: hide compare-at and show only main price

    priceWrapper.classList.remove('price--on-sale');
    saleBlock.style.display = 'none';

    regularSpan.textContent = formatMoney(finalPrice);
  }
}
    function updateExtraPrice() {
      let newExtraPrice = 0;
      let newExtraComparePrice = 0;
      const accessoryTotals = getSelectedAccessoryTotals();
      selectedKeycapExtras.forEach((keycapExtra) => {
        newExtraPrice += keycapExtra.price;
        newExtraComparePrice += keycapExtra.comparePrice;
      });
      selectedSwitchExtras.forEach((switchExtra) => {
        newExtraPrice += switchExtra.price;
        newExtraComparePrice += switchExtra.comparePrice;
      });
      newExtraPrice = newExtraPrice + accessoryTotals.price;
      newExtraComparePrice = newExtraComparePrice + accessoryTotals.comparePrice;
      extraPrice = newExtraPrice;
      extraComparePrice = newExtraComparePrice;
      updatePrice();
    }

    let scheduledPriceUpdate;
    function schedulePriceUpdate() {
      if (scheduledPriceUpdate) cancelAnimationFrame(scheduledPriceUpdate);
      scheduledPriceUpdate = requestAnimationFrame(() => {
        scheduledPriceUpdate = null;
        updateExtraPrice();
      });
    }

    document.addEventListener('variant:price-rendered', (event) => {
      if (String(event.detail?.sectionId) !== String(sectionId)) return;
      updateExtraPrice();
    });

    updateExtraPrice();

    document.querySelectorAll("[data-accessory-input]").forEach((input) => {
      input.addEventListener("change", updateExtraPrice);
    });

    addToCartForms.forEach((form) => {
      form.addEventListener("submit", async (event) => {
        event.stopImmediatePropagation();
        event.preventDefault();
        await submitConfiguredCart(form);
      }, { capture: true });
    });

    function validateExtraOptions(selector, variantAttributes) {
      const options = document.querySelectorAll(selector);
      const seenVariantIds = {};

      variantAttributes.forEach((attribute) => {
        seenVariantIds[attribute] = new Set();
      });

      options.forEach((option) => {
        const name = option.dataset.extraName || option.querySelector('.switch-name')?.textContent.trim() || 'Unnamed extra';
        const priceValue = option.dataset.priceCents;
        const priceIsValid = /^\d+$/.test(priceValue || '');
        const isNoExtraOption = priceValue === '0';
        const errors = [];

        if (!priceIsValid) {
          errors.push('data-price-cents must be a non-negative integer');
        }

        variantAttributes.forEach((attribute) => {
          const variantId = option.getAttribute(attribute) || '';
          const variantIsValid = /^\d+$/.test(variantId) && Number(variantId) > 0;

          if (!isNoExtraOption && !variantIsValid) {
            errors.push(`${attribute} must contain a positive Shopify variant ID`);
          }

          if (variantIsValid) {
            if (seenVariantIds[attribute].has(variantId)) {
              errors.push(`${attribute} duplicates variant ${variantId}`);
            }
            seenVariantIds[attribute].add(variantId);
          }
        });

        if (errors.length > 0) {
          option.dataset.configInvalid = 'true';
          option.setAttribute('aria-disabled', 'true');
          console.error(`[${productLabel} extras] Invalid configuration for "${name}": ${errors.join('; ')}`, option);
        }
      });
    }

    validateExtraOptions('[data-keycap-group="laserEtched"] .top_panel_language-language', [
      'data-black-variant-id',
      'data-white-variant-id'
    ]);
    if (config.validateSingleShotPbt) {
      validateExtraOptions('[data-keycap-group="singleShotPbt"] .top_panel_language-language', [
        'data-black-variant-id',
        'data-white-variant-id'
      ]);
    }
    validateExtraOptions('.top_panel_switch-switch', ['data-extra-variant-id']);

    document.querySelectorAll('[data-accessory-config-invalid="true"]').forEach((card) => {
      const name = card.querySelector('[data-accessory-title]')?.textContent.trim()
        || card.querySelector('.defy-accessory-card__title')?.textContent.trim()
        || 'Unnamed accessory';
      console.error(
        `[${productLabel} accessories] Variant ${card.dataset.configuredVariantId || '(blank)'} is not part of "${name}". The accessory has been disabled.`,
        card
      );
    });

    function handleLangExtras(evnt) {
      const selected = evnt.currentTarget;
      if (selected.dataset.configInvalid === 'true') return;
      const keycapGroup = selected.closest('[data-keycap-group]')?.dataset.keycapGroup;
      if (!keycapGroup) return;
      const selectionKey = `${keycapGroup}:${selected.dataset.extraName}`;

      const isSelected = selected.classList.toggle("selected");
      selected.setAttribute("aria-pressed", String(isSelected));

      if (isSelected) {
        selectedKeycapExtras.set(selectionKey, {
          variantId: currProduct.handle.includes("silver")
            ? selected.dataset.whiteVariantId
            : selected.dataset.blackVariantId,
          price: Number(selected.dataset.priceCents),
          comparePrice: Number(selected.dataset.comparePriceCents || selected.dataset.priceCents),
          name: selected.dataset.extraName
        });
      } else {
        selectedKeycapExtras.delete(selectionKey);
      }
      updateExtraPrice();
    }

    document.querySelectorAll('.top_panel_language-language').forEach((label)=>{
      label.setAttribute("role", "button");
      label.setAttribute("tabindex", "0");
      label.setAttribute("aria-pressed", "false");
      label.addEventListener("click", handleLangExtras);
      label.addEventListener("keydown", (event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          label.click();
        }
      });
    })

    const keycapPreview = document.querySelector('[data-keycap-hover-preview]');
    const keycapPreviewImage = keycapPreview?.querySelector('[data-keycap-hover-preview-image]');
    const keycapPreviewEnabled = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    let keycapPreviewHideTimer;

    function positionProductImagePreview(forceAccessoryViewportPreview = false) {
      const mediaWrapper = document.querySelector(
        '.keyboard-product-page .product__media-wrapper'
      );
      const mainMedia = document.querySelector(
        '.keyboard-product-page .product__media-wrapper .product__media-item:first-child .product__media'
      );
      const mainImage = mainMedia?.querySelector('img');
      if (!mainMedia || !mediaWrapper) return false;

      const mainMediaRect = mainMedia.getBoundingClientRect();
      const stickyTop = parseFloat(getComputedStyle(document.documentElement).fontSize) * 9;
      const previewTop = forceAccessoryViewportPreview ? 85 : stickyTop;
      const useViewportPreview = Boolean(
        forceAccessoryViewportPreview
        || (
          document.querySelector('.keyboard-product-page--sonsei')
          && mainMediaRect.bottom <= stickyTop
        )
      );

      keycapPreview.classList.toggle('is-viewport-preview', useViewportPreview);
      if (useViewportPreview) {
        document.body.appendChild(keycapPreview);
      } else {
        mainMedia.style.position = 'relative';
        mainMedia.appendChild(keycapPreview);
      }

      const imageRadius = mainImage ? getComputedStyle(mainImage).borderRadius : '16px';
      const availablePreviewHeight = window.innerHeight - previewTop - 24;
      const previewScale = useViewportPreview
        ? Math.min(
          1,
          Math.max(1, availablePreviewHeight) / Math.max(1, mainMediaRect.height)
        )
        : 1;
      const previewWidth = mainMediaRect.width * previewScale;
      const previewHeight = mainMediaRect.height * previewScale;
      const previewLeft = mainMediaRect.left + ((mainMediaRect.width - previewWidth) / 2);

      keycapPreview.style.setProperty('--preview-gallery-top', useViewportPreview ? `${previewTop}px` : '0px');
      keycapPreview.style.setProperty('--preview-gallery-left', useViewportPreview ? `${previewLeft}px` : '0px');
      keycapPreview.style.setProperty('--preview-gallery-width', useViewportPreview ? `${previewWidth}px` : '100%');
      keycapPreview.style.setProperty(
        '--preview-gallery-height',
        useViewportPreview ? `${previewHeight}px` : '100%'
      );
      keycapPreview.style.setProperty('--preview-media-top', '0px');
      keycapPreview.style.setProperty('--preview-media-left', '0px');
      keycapPreview.style.setProperty('--preview-media-width', '100%');
      keycapPreview.style.setProperty('--preview-media-height', '100%');
      keycapPreview.style.setProperty('--preview-media-radius', imageRadius);
      return true;
    }

    function showProductImagePreview(imageUrl, forceAccessoryViewportPreview = false) {
      if (
        !keycapPreviewEnabled
        || !keycapPreview
        || !keycapPreviewImage
      ) return;
      if (!imageUrl || !positionProductImagePreview(forceAccessoryViewportPreview)) return;

      clearTimeout(keycapPreviewHideTimer);
      keycapPreviewImage.onload = null;
      keycapPreviewImage.src = imageUrl;
      keycapPreview.hidden = false;
      requestAnimationFrame(() => {
        keycapPreview.classList.add('is-visible');
      });
    }

    const keycapVariantImageCache = new Map();

    async function getKeycapVariantImage(label) {
      const useWhiteVariant = currProduct.handle.includes("silver");
      const variantId = useWhiteVariant
        ? label.dataset.whiteVariantId
        : label.dataset.blackVariantId;
      if (!variantId) return "";
      if (keycapVariantImageCache.has(variantId)) return keycapVariantImageCache.get(variantId);

      try {
        const response = await fetch(`/variants/${variantId}.js`, {
          headers: { "Accept": "application/json" }
        });
        if (!response.ok) return "";
        const variant = await response.json();
        const imageUrl = variant.featured_image?.src || "";
        keycapVariantImageCache.set(variantId, imageUrl);
        return imageUrl;
      } catch (error) {
        console.error(`${productLabel}: could not load the keycap preview`, error);
        return "";
      }
    }

    async function showKeycapPreview(label) {
      const imageUrl = await getKeycapVariantImage(label);
      if (!label.matches(':hover') && document.activeElement !== label) return;
      showProductImagePreview(imageUrl);
    }

    function hideKeycapPreview() {
      if (!keycapPreview) return;
      keycapPreview.classList.remove('is-visible');
      keycapPreviewHideTimer = setTimeout(() => {
        if (!keycapPreview.classList.contains('is-visible')) {
          keycapPreview.hidden = true;
        }
      }, 180);
    }

    document.querySelectorAll('.top_panel_language-language[data-black-variant-id]').forEach((label) => {
      label.addEventListener('mouseenter', () => showKeycapPreview(label));
      label.addEventListener('mouseleave', hideKeycapPreview);
      label.addEventListener('focus', () => showKeycapPreview(label));
      label.addEventListener('blur', hideKeycapPreview);
    });

    function showMainLanguagePreview(languageInput) {
      const variantPicker = languageInput.closest('variant-radios');
      if (!variantPicker) return;

      const fieldsets = Array.from(variantPicker.querySelectorAll('fieldset'));
      const languageFieldset = languageInput.closest('fieldset');
      const languageIndex = fieldsets.indexOf(languageFieldset);
      if (languageIndex < 0) return;

      const previewOptions = fieldsets.map((fieldset) =>
        fieldset.querySelector('input:checked')?.value || null
      );
      previewOptions[languageIndex] = languageInput.value;

      const matchingVariant = currVariants.find((variant) =>
        variant.options.every((option, index) => option === previewOptions[index])
      ) || currVariants.find((variant) => variant.options[languageIndex] === languageInput.value);
      const imageUrl = matchingVariant?.featured_image?.src
        || matchingVariant?.image?.src
        || matchingVariant?.image
        || '';

      showProductImagePreview(imageUrl);
    }

    document.querySelectorAll('.option-name-language input[type="radio"]').forEach((input) => {
      const label = input.closest('.atributte-item')?.querySelector('label');
      if (!label) return;

      label.addEventListener('mouseenter', () => showMainLanguagePreview(input));
      label.addEventListener('mouseleave', hideKeycapPreview);
      input.addEventListener('focus', () => showMainLanguagePreview(input));
      input.addEventListener('blur', hideKeycapPreview);
    });

    function showColorPreview(colorOption) {
      if (config.colorPreviewMatchMode === 'exact') {
        const selectedOptions = [optionL1[currOpt1], optionL2[currOpt2], optionL3[currOpt3]];
        const matchingVariant = colorPreviewVariants[colorOption.dataset.colorPreview]?.find((variant) =>
          selectedOptions.every((option, index) => option === undefined || variant.options[index] === option)
        );
        showProductImagePreview(matchingVariant?.imageUrl || colorOption.dataset.colorPreviewImage);
        return;
      }

      const variantPicker = document.querySelector(`variant-radios[data-section="${sectionId}"]`);
      const previewVariants = colorPreviewVariants[colorOption.dataset.colorPreview] || [];
      const languageIndex = currProduct.options.findIndex((optionName) =>
        optionName.toLowerCase() === 'language'
      );
      const selectedLanguage = variantPicker
        ?.querySelector('.option-name-language input:checked')
        ?.value || currVariant.options[languageIndex];
      const normalizeLanguage = (language) => String(language || '')
        .replace(/\s+(ANSI|ISO)\s*$/i, '')
        .trim()
        .toLowerCase();
      const matchingVariant = previewVariants.find((variant) =>
        normalizeLanguage(variant.options[languageIndex]) === normalizeLanguage(selectedLanguage)
      );

      showProductImagePreview(matchingVariant?.imageUrl || colorOption.dataset.colorPreviewImage);
    }

    document.querySelectorAll('[data-color-preview]').forEach((colorOption) => {
      const link = colorOption.closest('a');
      colorOption.addEventListener('mouseenter', () => showColorPreview(colorOption));
      colorOption.addEventListener('mouseleave', hideKeycapPreview);
      link?.addEventListener('focus', () => showColorPreview(colorOption));
      link?.addEventListener('blur', hideKeycapPreview);
    });

    document.querySelectorAll('[data-accessory-preview-image]').forEach((card) => {
      const imageUrl = card.dataset.accessoryPreviewImage;
      const input = card.querySelector('[data-accessory-input]');
      const info = card.querySelector('.enhancement-info');
      if (imageUrl) {
        const preloadedImage = new Image();
        preloadedImage.src = imageUrl;
      }
      card.addEventListener('mouseenter', () => showProductImagePreview(imageUrl, true));
      card.addEventListener('mouseleave', hideKeycapPreview);
      input?.addEventListener('focus', () => showProductImagePreview(imageUrl, true));
      input?.addEventListener('blur', hideKeycapPreview);
      info?.addEventListener('click', (event) => event.preventDefault());
    });

    function handleSwitchExtras(evnt) {
      const selected = evnt.currentTarget;
      if (selected.dataset.configInvalid === 'true') return;
      const selectionKey = selected.dataset.extraVariantId;

      const isSelected = selected.classList.toggle("selected");
      selected.setAttribute("aria-pressed", String(isSelected));

      if (isSelected) {
        selectedSwitchExtras.set(selectionKey, {
          variantId: selectionKey,
          price: Number(selected.dataset.priceCents),
          comparePrice: Number(selected.dataset.comparePriceCents || selected.dataset.priceCents),
          name: selected.dataset.extraName
        });
      } else {
        selectedSwitchExtras.delete(selectionKey);
      }
      updateExtraPrice();
    }

    document.querySelectorAll('.top_panel_switch-switch').forEach((label)=>{
      label.setAttribute("role", "button");
      label.setAttribute("tabindex", "0");
      label.setAttribute("aria-pressed", "false");
      label.addEventListener("click", handleSwitchExtras);
      label.addEventListener("keydown", (event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          label.click();
        }
      });
    })

    function handleAddOnsWl(evnt) {
      const selected = evnt.currentTarget;
      globalAddOnOpts[0] = selected.classList.contains("selected") ? 0 : 1;
      selected.classList.toggle("selected", globalAddOnOpts[0] === 1);
      selected.setAttribute("aria-pressed", globalAddOnOpts[0] === 1 ? "true" : "false");
      updateUnderglowAvailability();
      updateSelectedAddOns();
    }

    document.querySelectorAll('.add-on-attribute-item-wireless').forEach((label)=>{
      label.addEventListener("click", handleAddOnsWl);
    })

    function handleAddOnsTt(evnt) {
      const selected = evnt.currentTarget;
      globalAddOnOpts[1] = selected.classList.contains("selected") ? 0 : 1;
      selected.classList.toggle("selected", globalAddOnOpts[1] === 1);
      selected.setAttribute("aria-pressed", globalAddOnOpts[1] === 1 ? "true" : "false");
      updateUnderglowAvailability();
      updateSelectedAddOns();
    }

    document.querySelectorAll('.add-on-attribute-item-tenting').forEach((label)=>{
      label.addEventListener("click", handleAddOnsTt);
    })

    function handleAddOnsUg(evnt) {
      const selected = evnt.currentTarget;
      if (selected.disabled) return;

      globalAddOnOpts[2] = selected.classList.contains("selected") ? 0 : 1;
      selected.classList.toggle("selected", globalAddOnOpts[2] === 1);
      selected.setAttribute("aria-pressed", globalAddOnOpts[2] === 1 ? "true" : "false");
      updateSelectedAddOns();
    }

    document.querySelectorAll('.add-on-attribute-item-underglow').forEach((label)=>{
      label.addEventListener("click", handleAddOnsUg);
    })

    function updateUnderglowAvailability() {
      const underglowOption = document.querySelector('.add-on-attribute-item-underglow');
      if (!underglowOption) return;

      const canSelectUnderglow = globalAddOnOpts[0] === 1 && globalAddOnOpts[1] === 1;
      underglowOption.disabled = !canSelectUnderglow;

      if (!canSelectUnderglow) {
        globalAddOnOpts[2] = 0;
        underglowOption.classList.remove("selected");
        underglowOption.setAttribute("aria-pressed", "false");
      }
    }

    function updateSelectedAddOns() {
      const allAddOnInputs = document.querySelectorAll('input[name="Add ons"]');
      const combo = globalAddOnOpts[0] + globalAddOnOpts[1] * 2 + globalAddOnOpts[2] * 4;
      const selInput = Array.from(allAddOnInputs).find((input) => {
        const normalizedValue = input.value.split('/')[0].trim().toLowerCase();
        const optionFeatures = {
          wireless: normalizedValue.includes('wireless'),
          tenting: normalizedValue.includes('tenting'),
          underglow: normalizedValue.includes('underglow')
        };

        return optionFeatures.wireless === (globalAddOnOpts[0] === 1)
          && optionFeatures.tenting === (globalAddOnOpts[1] === 1)
          && optionFeatures.underglow === (globalAddOnOpts[2] === 1);
      });

      if (!selInput) {
        console.error(
          `[${productLabel} add-ons] Could not find the Shopify option for combination ${combo}.`,
          Array.from(allAddOnInputs).map((input) => input.value)
        );
        return;
      }

      selInput.checked = true;
      selInput.dispatchEvent(new Event("change", {
        bubbles: true,
        cancelable: true,
        view: window,
      }));
    }

    const optionValueLists = [optionL1, optionL2, optionL3];
    document
      .querySelectorAll(`variant-radios[data-section="${sectionId}"] input[type="radio"]`)
      .forEach((input) => {
        input.addEventListener('change', () => {
          const optionIndex = currProduct.options.indexOf(input.name);
          const valueIndex = optionValueLists[optionIndex]?.indexOf(input.value);
          if (valueIndex === undefined || valueIndex < 0) return;

          if (optionIndex === 0) currOpt1 = valueIndex;
          if (optionIndex === 1) currOpt2 = valueIndex;
          if (optionIndex === 2) currOpt3 = valueIndex;

          schedulePriceUpdate();
        });
      });

  });

})();
